import $ from 'jquery';
import {isTouchDevice} from '../../../assets/common/scripts/IsTouchDevice'
$(()=>{
    const nav = $('.header-navigation .navigation');
    nav.find('[data-toggle="dropdown"],.dropdown-toggle').each((index,el)=>{
        $(el).html(`<span>${el.textContent}</span>`);
    }).on('click',e=>{
        e.preventDefault();
        e.stopPropagation();
        if(e.target.tagName !== 'SPAN'){
            //Pfeil klick, wird von bootstrap js gesteuert.
        }else{
            const {href=""} = e.target.parentElement;
            href && (location.href = href);
        }
    });
});